'use client'

import { useTranslation as useI18nTranslation } from 'react-i18next'

// Custom hook that safely handles SSR and client-side translation
export function useClientTranslation(namespace?: string) {
  // Always use the actual translation hook
  // This ensures consistent behavior between server and client
  const translation = useI18nTranslation(namespace)
  
  // Return the translation object directly
  // i18next handles SSR compatibility internally
  return translation
}